import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Building, FileText, Shield, Users, Briefcase, Gavel } from "lucide-react";

const services = [
  {
    icon: <Building className="w-8 h-8 text-primary" />,
    title: "LLC Formation",
    description: "Complete LLC setup with operating agreements, EIN registration, and state compliance."
  },
  {
    icon: <FileText className="w-8 h-8 text-primary" />,
    title: "Corporation Setup",
    description: "C-Corp and S-Corp formation with bylaws, corporate resolutions, and stock certificates."
  },
  {
    icon: <Shield className="w-8 h-8 text-primary" />,
    title: "Registered Agent",
    description: "Professional registered agent service to receive legal documents and maintain compliance."
  },
  {
    icon: <Users className="w-8 h-8 text-primary" />,
    title: "Partnership Formation",
    description: "General and limited partnership agreements with clear terms and profit-sharing structures."
  },
  {
    icon: <Briefcase className="w-8 h-8 text-primary" />,
    title: "Business Licenses",
    description: "Help obtaining required federal, state, and local business licenses and permits."
  },
  {
    icon: <Gavel className="w-8 h-8 text-primary" />,
    title: "Legal Compliance",
    description: "Ongoing compliance support including annual reports, state filings, and corporate maintenance."
  }
];

const CompanyFormationServices = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Complete Business Formation Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From entity selection to legal compliance, we handle every aspect of starting your business.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Card key={index} className="border hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="mb-4">{service.icon}</div>
                <CardTitle className="text-xl">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyFormationServices;